"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isControlArray = exports.isRiskArray = exports.isProcessArray = exports.isControl = exports.isRisk = exports.isProcess = void 0;
var lodash_1 = __importDefault(require("lodash"));
var PRC_1 = require("./PRC");
function isProcess(value) {
    return value.type === PRC_1.PRCType.process;
}
exports.isProcess = isProcess;
function isRisk(value) {
    return value.type === PRC_1.PRCType.risk;
}
exports.isRisk = isRisk;
function isControl(value) {
    return value.type === PRC_1.PRCType.control;
}
exports.isControl = isControl;
function isProcessArray(value) {
    return lodash_1.default.every(value, function (element) { return element.type === PRC_1.PRCType.process; });
}
exports.isProcessArray = isProcessArray;
function isRiskArray(value) {
    return lodash_1.default.every(value, function (element) { return element.type === PRC_1.PRCType.risk; });
}
exports.isRiskArray = isRiskArray;
function isControlArray(value) {
    return lodash_1.default.every(value, function (element) { return element.type === PRC_1.PRCType.control; });
}
exports.isControlArray = isControlArray;
//# sourceMappingURL=PRCUtils.js.map